import { Temporal } from '@js-temporal/polyfill';

export function parseTemporal(date) {
    if (!date) return null;
    const hasTZ = /[zZ]|[+-]\d{2}:\d{2}$/.test(date);

    if (hasTZ) {
        return Temporal.Instant.from(date).toZonedDateTimeISO('UTC');
    }

    return Temporal.PlainDateTime.from(date);
}

export function getDate(date) {
    if (!date) return null;
    const dt = parseTemporal(date);
    const d = dt.toPlainDate();
    return `${d.month}/${d.day}/${d.year}`;
}

export function getDateAndTime(date) {
    if (!date) return null;
    const dt = parseTemporal(date);
    const d = dt.toPlainDate();
    return `${d.month}/${d.day}/${d.year}`;
}

export function getDateAndTimeStamp(date) {
    if (!date) return null;
    const dt = parseTemporal(date);
    const t = dt.toPlainTime();

    const hour12 = t.hour % 12 || 12;
    const ampm = t.hour < 12 ? 'AM' : 'PM';

    return `${hour12}:${String(t.minute).padStart(2, '0')} ${ampm}`;
}

